/* import __COLOCATED_TEMPLATE__ from './discovery-banner.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import templateOnlyComponent from '@ember/component/template-only';

const SlackDiscoveryBanner = templateOnlyComponent();

export default SlackDiscoveryBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Slack::DiscoveryBanner': typeof SlackDiscoveryBanner;
  }
}
